export default "__VITE_ASSET__CCbMFwzg__"